// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components-wpbbsa/form-item-professional-banking/form-item-professional-banking.component.scss
// module id = 972
// module chunks = 0